import { MainMenu } from './src/mainMenu';

document.addEventListener("DOMContentLoaded", () => {
	const menu = document.getElementById("menu");
	// NOTE: toggle id syntax is backwards to preserve URL slugs
	const toggleOpen = document.getElementById('menu-close');

	if (menu && toggleOpen) {
		new MainMenu(menu, toggleOpen, {
			toggles: '.menuToggle',
			focusLock: {
				dialog: '.menu',
				return: '.menuToggle--open',
				toggle: '.menuToggle--close'
			},
			styleClass: {
				menuOpen: 'hasMenuOpen'
			},
			duration: 400,
			easing: 'easeOutExpo'
		});
	}
});

